"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactHooks = require("@trycourier/react-hooks");

var _styled = require("../Message/styled");

var _lib = require("../../lib");

var _useHover3 = _interopRequireDefault(require("../../hooks/use-hover"));

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var _actions = _interopRequireDefault(require("./actions"));

var _useOnScreen = require("../../hooks/use-on-screen");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ClickableContainer = _styledComponents["default"].a.withConfig({
  displayName: "Message__ClickableContainer",
  componentId: "sc-1wfky41-0"
})(function (_ref) {
  var _theme$brand, _theme$brand$colors, _theme$message$clicka, _theme$message;

  var theme = _ref.theme;
  var primaryColor = (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary;
  var tcPrimaryColor = (0, _tinycolor["default"])(primaryColor);
  return (0, _deepExtend["default"])({
    "*, &": {
      "text-decoration": "none"
    },
    ".message-container.hover": {
      background: tcPrimaryColor.setAlpha(0.14)
    }
  }, (_theme$message$clicka = (_theme$message = theme.message) === null || _theme$message === void 0 ? void 0 : _theme$message.clickableContainer) !== null && _theme$message$clicka !== void 0 ? _theme$message$clicka : {});
});

var Contents = _styledComponents["default"].div.withConfig({
  displayName: "Message__Contents",
  componentId: "sc-1wfky41-1"
})(function (_ref2) {
  var _theme$message2;

  var theme = _ref2.theme;
  return _objectSpread({
    marginRight: "auto",
    textAlign: "left",
    marginLeft: 12
  }, (_theme$message2 = theme.message) === null || _theme$message2 === void 0 ? void 0 : _theme$message2.contents);
});

var UnreadIndicator = _styledComponents["default"].div.withConfig({
  displayName: "Message__UnreadIndicator",
  componentId: "sc-1wfky41-2"
})(function (_ref3) {
  var _theme$brand2, _theme$brand2$colors, _theme$message3;

  var theme = _ref3.theme,
      read = _ref3.read;
  var primaryColor = (_theme$brand2 = theme.brand) === null || _theme$brand2 === void 0 ? void 0 : (_theme$brand2$colors = _theme$brand2.colors) === null || _theme$brand2$colors === void 0 ? void 0 : _theme$brand2$colors.primary;
  return (0, _deepExtend["default"])({
    visibility: read ? "hidden" : "visible",
    height: "auto",
    width: 2,
    background: primaryColor,
    position: "absolute",
    left: "1px",
    top: "1px",
    bottom: "1px"
  }, theme === null || theme === void 0 ? void 0 : (_theme$message3 = theme.message) === null || _theme$message3 === void 0 ? void 0 : _theme$message3.unreadIndicator);
});

var MessageContainer = _styledComponents["default"].div.withConfig({
  displayName: "Message__MessageContainer",
  componentId: "sc-1wfky41-3"
})(function (_ref4) {
  var _theme$message4;

  var theme = _ref4.theme;
  return (0, _deepExtend["default"])({
    transition: "background 200ms ease-in-out",
    display: "flex",
    position: "relative",
    padding: "12px",
    minHeight: 60,
    backgroundColor: "#F9FAFB",
    borderBottom: "1px solid rgb(222, 232, 240)",
    "&.read": {
      background: "#F2F6F9",
      ".icon": {
        filter: "grayscale(100%)",
        opacity: "0.3"
      }
    }
  }, theme === null || theme === void 0 ? void 0 : (_theme$message4 = theme.message) === null || _theme$message4 === void 0 ? void 0 : _theme$message4.container);
});

var Message = function Message(_ref5) {
  var areActionsHovered = _ref5.areActionsHovered,
      isMessageHovered = _ref5.isMessageHovered,
      read = _ref5.read,
      renderedIcon = _ref5.renderedIcon,
      renderTextBlock = _ref5.renderTextBlock,
      textBlocks = _ref5.textBlocks,
      title = _ref5.title;
  return /*#__PURE__*/_react["default"].createElement(MessageContainer, {
    className: (0, _classnames["default"])("message-container", {
      hover: isMessageHovered && !areActionsHovered,
      read: read
    })
  }, /*#__PURE__*/_react["default"].createElement(UnreadIndicator, {
    read: read
  }), renderedIcon, /*#__PURE__*/_react["default"].createElement(Contents, null, /*#__PURE__*/_react["default"].createElement(_styled.Title, {
    read: read
  }, title), textBlocks === null || textBlocks === void 0 ? void 0 : textBlocks.map(function (block, index) {
    if (renderTextBlock) {
      var Block = renderTextBlock;
      return /*#__PURE__*/_react["default"].createElement(Block, (0, _extends2["default"])({}, block, {
        key: index
      }));
    }

    return /*#__PURE__*/_react["default"].createElement(_styled.TextBlock, {
      key: index,
      "data-testid": "message-body"
    }, block.text && /*#__PURE__*/_react["default"].createElement(_markdownToJsx["default"], null, block.text));
  })));
};

var MessageWrapper = function MessageWrapper(_ref6) {
  var _brand$inapp, _ref7, _brand$inapp2, _brand$inapp2$icons, _renderBlocks$text;

  var blocks = _ref6.blocks,
      created = _ref6.created,
      data = _ref6.data,
      opened = _ref6.opened,
      defaultIcon = _ref6.defaultIcon,
      formatDate = _ref6.formatDate,
      messageId = _ref6.messageId,
      icon = _ref6.icon,
      openLinksInNewTab = _ref6.openLinksInNewTab,
      read = _ref6.read,
      renderBlocks = _ref6.renderBlocks,
      title = _ref6.title,
      trackingIds = _ref6.trackingIds;

  var _useHover = (0, _useHover3["default"])(),
      _useHover2 = (0, _slicedToArray2["default"])(_useHover, 2),
      messageHoverRef = _useHover2[0],
      isMessageHovered = _useHover2[1];

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      areActionsHovered = _useState2[0],
      setAreActionsHovered = _useState2[1];

  var _useInbox = (0, _reactHooks.useInbox)(),
      brand = _useInbox.brand,
      markMessageRead = _useInbox.markMessageRead,
      markMessageOpened = _useInbox.markMessageOpened;

  var handleClickMessage = function handleClickMessage(event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();

    if (!messageId) {
      return;
    }

    if (!read && trackingIds !== null && trackingIds !== void 0 && trackingIds.clickTrackingId && trackingIds !== null && trackingIds !== void 0 && trackingIds.readTrackingId) {
      // mark message read, but don't fire the event as the backend will do it for us,
      // we just want to set the message as read here in our local state
      markMessageRead(messageId);
    }
  };

  (0, _useOnScreen.useOnScreen)(messageHoverRef, function () {
    if (opened || !messageId) {
      return;
    }

    markMessageOpened(messageId);
  });
  var renderedIcon = (0, _styled.getIcon)(
  /* priority:
    1. from message
    2. from props.defaultIcon
    3. from props.brand.inapp.icons.message
    4. from remote brand.inapp.icons.message
  */
  brand !== null && brand !== void 0 && (_brand$inapp = brand.inapp) !== null && _brand$inapp !== void 0 && _brand$inapp.disableMessageIcon ? false : (_ref7 = icon || defaultIcon) !== null && _ref7 !== void 0 ? _ref7 : brand === null || brand === void 0 ? void 0 : (_brand$inapp2 = brand.inapp) === null || _brand$inapp2 === void 0 ? void 0 : (_brand$inapp2$icons = _brand$inapp2.icons) === null || _brand$inapp2$icons === void 0 ? void 0 : _brand$inapp2$icons.message, true // 36px icon
  );
  var formattedTime = formatDate ? formatDate(created) : (0, _lib.getTimeAgoShort)(created);
  var blocksByType = (0, _react.useMemo)(function () {
    return blocks === null || blocks === void 0 ? void 0 : blocks.reduce(function (acc, cur) {
      if (cur.type === "text") {
        acc.text.push(cur);
      }

      if (cur.type === "action") {
        acc.action.push(cur);
      }

      return acc;
    }, {
      action: [],
      text: []
    });
  }, [blocks]);
  var clickAction = (0, _react.useMemo)(function () {
    var _blocksByType$action;

    if (data !== null && data !== void 0 && data.clickAction) {
      return data.clickAction;
    }

    if (!(blocksByType !== null && blocksByType !== void 0 && blocksByType.action.length) || ((_blocksByType$action = blocksByType.action) === null || _blocksByType$action === void 0 ? void 0 : _blocksByType$action.length) > 1) {
      return;
    }

    return blocksByType.action[0].url;
  }, [data === null || data === void 0 ? void 0 : data.clickAction, blocksByType === null || blocksByType === void 0 ? void 0 : blocksByType.action]);
  var containerProps = {};

  if (clickAction) {
    containerProps.href = clickAction;
    containerProps.onMouseDown = handleClickMessage;

    if (openLinksInNewTab) {
      containerProps = _objectSpread(_objectSpread({}, containerProps), {}, {
        target: "_blank",
        rel: "noreferrer"
      });
    }
  }

  var renderedMessage = (0, _react.useMemo)(function () {
    var _blocksByType$text;

    return /*#__PURE__*/_react["default"].createElement(Message, {
      areActionsHovered: areActionsHovered,
      isMessageHovered: isMessageHovered,
      read: read,
      renderedIcon: renderedIcon,
      renderTextBlock: renderBlocks === null || renderBlocks === void 0 ? void 0 : renderBlocks.text,
      textBlocks: (_blocksByType$text = blocksByType === null || blocksByType === void 0 ? void 0 : blocksByType.text) !== null && _blocksByType$text !== void 0 ? _blocksByType$text : [],
      title: title
    });
  }, [areActionsHovered, blocksByType === null || blocksByType === void 0 ? void 0 : blocksByType.text, formattedTime, isMessageHovered, read, renderBlocks === null || renderBlocks === void 0 ? void 0 : renderBlocks.text, renderedIcon, title]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: messageHoverRef,
    "data-testid": "inbox-message",
    style: {
      position: "relative"
    }
  }, containerProps.href ? /*#__PURE__*/_react["default"].createElement(ClickableContainer, containerProps, renderedMessage) : renderedMessage, /*#__PURE__*/_react["default"].createElement(_actions["default"], {
    formattedTime: formattedTime,
    hasBody: Boolean(renderBlocks === null || renderBlocks === void 0 ? void 0 : (_renderBlocks$text = renderBlocks.text) === null || _renderBlocks$text === void 0 ? void 0 : _renderBlocks$text.length),
    isMessageHovered: isMessageHovered,
    messageId: messageId,
    read: read,
    setAreActionsHovered: setAreActionsHovered,
    trackingIds: trackingIds
  }));
};

var _default = MessageWrapper;
exports["default"] = _default;